import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from './Roundel.module.scss'

export const DownloadRoundelIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  className,
  ...rest
}) => {
  return (
    <Icon
      className={classnames(styles.download, className)}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <path
        d="M24,19.5 C24.2445019,19.4960119 24.4560163,19.6694537 24.5,19.91 L24.5,22 C24.5,23.58 23.47,24.44 21.63,24.5 L10.14,24.5 C9.84,24.49 9.62,24.46 9.37,24.4 C8.27,24.18 7.57,23.47 7.51,22.2 L7.5,22 L7.5,20 C7.47514719,19.7238576 7.67885763,19.4798528 7.955,19.455 C8.23114237,19.4301472 8.47514718,19.6338576 8.5,19.91 L8.5,22 C8.5,22.89 8.86,23.28 9.57,23.43 C9.81,23.48 10.02,23.5 10.35,23.5 L21.42,23.5 C22.82,23.5 23.44,23.07 23.5,22.14 L23.5,20 C23.5,19.72 23.72,19.5 24,19.5 Z M16,4.9999735 C16.5086257,4.99632612 16.9389766,5.37503494 17,5.88 L17,17.58 L21.3,13.29 C21.6556384,12.9404312 22.2144676,12.9063042 22.61,13.21 L22.71,13.29 C23.0653173,13.6470514 23.0995961,14.2126508 22.79,14.61 L22.71,14.71 L16.71,20.71 C16.4817813,20.9443523 16.1516804,21.0493844 15.83,20.99 L15.82,20.99 C15.7364938,20.9753101 15.6556189,20.9483518 15.58,20.91 C15.5422611,20.8920317 15.505539,20.8720015 15.47,20.85 C15.3884697,20.8007819 15.3143881,20.7401697 15.25,20.67 L9.3,14.7 C8.91391599,14.3291628 8.88835363,13.7200497 9.24200933,13.3181682 C9.59566502,12.9162867 10.203085,12.864198 10.62,13.2 L10.72,13.28 L15,17.6 L15,6 C15,5.44771525 15.4477153,4.9999735 16,4.9999735 Z"
        data-testid="roundel-icon-download"
        fill="#ffffff"
        className={styles.white}
      />
    </Icon>
  )
}
